import type { VerifyPurchaseRequest } from "@/shared/api/generated-backend"
import {
	appleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGet,
	subscriptionCancelApiV1SubscriptionCancelPost,
	subscriptionStatusApiV1SubscriptionStatusGet,
	verifyPurchaseApiV1SubscriptionVerifyPurchasePost,
} from "@/shared/api/generated-backend"
import { deadlineFetch } from "@/shared/api/http"
import type { PurchaseVerification, SubscriptionStatus } from "../model/types"

const PURCHASE_VERIFY_TIMEOUT_MS = 30_000

export async function getSubscriptionStatus(): Promise<SubscriptionStatus> {
	return subscriptionStatusApiV1SubscriptionStatusGet()
}

export async function getAppleAppAccountToken(): Promise<string> {
	const { app_account_token } =
		await appleAppAccountTokenApiV1SubscriptionAppleAppAccountTokenGet()
	return app_account_token
}

export async function cancelSubscription() {
	return subscriptionCancelApiV1SubscriptionCancelPost()
}

export async function sendPurchaseVerification(
	body: VerifyPurchaseRequest,
): Promise<PurchaseVerification> {
	const { subscription, client_action } =
		await verifyPurchaseApiV1SubscriptionVerifyPurchasePost({
			body,
			fetch: deadlineFetch(PURCHASE_VERIFY_TIMEOUT_MS),
		})
	return { subscription, clientAction: client_action }
}
